export default {
      id: "echo-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#echo",
      toString: function () {
        return this.url;
      }
    }